module.exports = import("https://cdn.jsdelivr.net/npm/mermaid@11/dist/mermaid.esm.min.mjs");;